import { render } from "./ContributionTable.vue?vue&type=template&id=a3aa88fc&scoped=true"
import script from "./ContributionTable.vue?vue&type=script&lang=js"
export * from "./ContributionTable.vue?vue&type=script&lang=js"

import "./ContributionTable.vue?vue&type=style&index=0&id=a3aa88fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3aa88fc"]])

export default __exports__